import React, { useContext, useEffect, useState } from 'react';

import { PagesContext } from '../store/PagesContext';

import UList from 'components/Lists/UList';

import Columns from '../components/Columns';
import QSBSPopups from '../components/popups/QSBSPopups';

const IsoH = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const openQSBSPopup = () => setIsPopupOpen(true);

  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage('isoG'), []);

  const sideContent = (
    <>
      If you sell your shares within 1 year of exercising, less than 2 years after your grant date, AND they{' '}
      <span className='color-black c-pointer' onClick={openQSBSPopup}>
        meet the criteria to qualify as QSBS
      </span>{' '}
      (qualified small business stocks) then:
    </>
  );

  return (
    <>
      <Columns sideContent={sideContent}>
        <UList>
          <li>You will be subject to pay only a portion of federal taxes.</li>
          <li>Or you will be exempt from paying taxes altogether.</li>
        </UList>
        <p>
          Consult with a tax advisor or refer to Section 1202 of the IRS Code for more information on{' '}
          <span className='color-yellow c-pointer' onClick={openQSBSPopup}>
            QSBS.
          </span>
        </p>
      </Columns>

      <QSBSPopups isQSBSPopupOpen={isPopupOpen} setIsQSBSPopupOpen={setIsPopupOpen} />
    </>
  );
};

export default IsoH;
